import { useEffect, useRef } from "react";
import { useNavigate } from "react-router-dom";
import MoonMark from "@/components/MoonMark";

const API = process.env.REACT_APP_BACKEND_URL;

// REMINDER: DO NOT HARDCODE THE URL, OR ADD ANY FALLBACKS OR REDIRECT URLS, THIS BREAKS THE AUTH
const AuthCallback = () => {
  const navigate = useNavigate();
  const hasProcessed = useRef(false);

  useEffect(() => {
    if (hasProcessed.current) return;
    hasProcessed.current = true;

    const sessionId = window.location.hash.match(/session_id=([^&]+)/)?.[1];
    if (!sessionId) {
      navigate("/admin", { replace: true, state: { authError: "Sign-in did not complete. Try again." } });
      return;
    }

    fetch(`${API}/api/auth/session`, {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      credentials: "include",
      body: JSON.stringify({ session_id: sessionId }),
    })
      .then(async (res) => {
        if (!res.ok) {
          const data = await res.json().catch(() => ({}));
          throw new Error(typeof data.detail === "string" ? data.detail : "Sign-in failed");
        }
        return res.json();
      })
      .then((user) => {
        navigate("/admin", { replace: true, state: { user } });
      })
      .catch((err) => {
        navigate("/admin", {
          replace: true,
          state: { authError: err.message || "Sign-in failed. Try again." },
        });
      });
  }, [navigate]);

  return (
    <div className="flex min-h-screen flex-col items-center justify-center gap-6 bg-ink">
      <MoonMark className="h-12 w-12 animate-spin text-gold" style={{ animationDuration: "6s" }} />
      <p className="font-jmono text-[10px] uppercase tracking-[0.4em] text-slate-500">
        Opening the vault…
      </p>
    </div>
  );
};

export default AuthCallback;
